import { executeGET } from "../ServiceMethods";
import { removeUserCredentials, isBusinessSwitched } from "../LocalStorage";
import { toast } from "react-toastify";
import { SessionTimeout } from "../ErrorMessages";

export const GetMappedBusinessList = async (data, cb) => {
  try {
    const res = await executeGET(
      "/businessuser/mapped-business-list",
      data // yeh query params ban jayega
    );

    const responseData = res?.data ? res.data : {};
    return responseData;

  } catch (error) {
    if (error?.response?.data?.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      });

      removeUserCredentials();
      cb && cb();
    } else {
      return false;
    }
  }
};
